import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface PlusFilledIconProps extends IconProps {
  color?: TIconColor;
}

// Small filled plus badge used on the receipt column (required vs optional-add states).
const PlusFilledIcon = ({ size, variant, className, color = 'purple' }: PlusFilledIconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, iconColor: color, className }))}
    aria-hidden="true"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 0C5.77614 0 6 0.223858 6 0.5V5H10.5C10.7761 5 11 5.22386 11 5.5C11 5.77614 10.7761 6 10.5 6H6V10.5C6 10.7761 5.77614 11 5.5 11C5.22386 11 5 10.7761 5 10.5V6H0.5C0.223858 6 0 5.77614 0 5.5C0 5.22386 0.223858 5 0.5 5H5V0.5C5 0.223858 5.22386 0 5.5 0Z"
      fill="currentColor"
    />
  </svg>
);

export default PlusFilledIcon;
